import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { formatDate } from '../../../../utils/Utils';
import { getAuditActionLabel, getAuditDetailsSummary } from '../auditActionLabels';

/**
 * Chip neutro para a ação da trilha (mesmo visual, sem cor por ação, de AuditActionChip
 * em Admin Geral > Auditoria, já que a lista de ações pode crescer).
 */
function ActionChip({ action, details }) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: '#E3F2FD',
        border: '1px solid #BBDEFB',
        width: 'fit-content',
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, fontSize: '0.75rem', lineHeight: 1, color: '#1565C0', whiteSpace: 'nowrap' }}
      >
        {getAuditActionLabel(action, details)}
      </Typography>
    </Box>
  );
}

/**
 * Formata 'YYYY-MM-DD HH:MM:SS' (fuso do servidor) com formatDate() do projeto.
 * @param {string} dateStr
 * @returns {string}
 */
function formatCreatedAt(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '—';
  return formatDate(date);
}

/**
 * CompanyAuditRow - Linha da tabela de Auditoria da clínica (LGPD L-14)
 * @param {Object} props
 * @param {Object} props.entry - id, createdAt, action, userId, userName, patientId, patientName, ip, details
 * @param {boolean} props.hidePatientColumn - true quando a tela já está filtrada por um paciente
 */
function CompanyAuditRow({ entry, hidePatientColumn = false }) {
  const { createdAt, action, userName, patientName, patientId, ip, details } = entry;

  return (
    <TableRow hover>
      <TableCell>
        <Typography variant="body2">{formatCreatedAt(createdAt)}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" color="text.secondary">{userName || '—'}</Typography>
      </TableCell>

      <TableCell><ActionChip action={action} details={details} /></TableCell>

      {!hidePatientColumn && (
        <TableCell>
          {patientId ? (
            <Typography variant="body2">{patientName || `Paciente #${patientId}`}</Typography>
          ) : (
            <Typography variant="body2" color="text.disabled">—</Typography>
          )}
        </TableCell>
      )}

      <TableCell>
        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'ui-monospace, Menlo, Consolas, monospace', fontSize: '0.8125rem' }}>
          {ip || '—'}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" color="text.secondary" noWrap sx={{ maxWidth: 320 }}>
          {getAuditDetailsSummary(details) || '—'}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default CompanyAuditRow;
